import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-[900px] mx-auto text-center">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950 mb-6">
            {aboutData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {aboutData.description}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {aboutData.features.map((f, i) => (
              <span
                key={i}
                className="px-4 py-2 bg-background-100 text-foreground-700 text-xs md:text-sm font-medium rounded-full border border-background-200/70 whitespace-nowrap"
              >
                {f}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}